import Swiper from './swiper';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "./body-scroll-lock.js";

export default function initCarousels() {
  // Membership Cards (Type One)
  $(".cb-membership-cards.cb-membership-cards--type-one .cb-membership-cards__carousel-block .swiper-container").each(function (index, element) {
    var $this = $(this);
    $this.addClass("membership-cards-type-one-" + index);
    $this.parent().find('.swiper-button-next').addClass("swiper-button-next-membership-cards-type-one-" + index);
    $this.parent().find('.swiper-button-prev').addClass("swiper-button-prev-membership-cards-type-one-" + index);
    $this.parent().find('.swiper-pagination').addClass("swiper-pagination-membership-cards-type-one-" + index);
    var membershipCards = new Swiper(".membership-cards-type-one-" + index, {
      init: false,
      loop: true,
      // simulateTouch: false,
      speed: 750,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      mousewheel: {
        sensitivity: 1,
        forceToAxis: true,
        invert: true
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      pagination: {
        el: '.swiper-pagination.swiper-pagination-membership-cards-type-one-' + index,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next.swiper-button-next-membership-cards-type-one-' + index,
        prevEl: '.swiper-button-prev.swiper-button-prev-membership-cards-type-one-' + index
      },
      on: {
        init: function () {
          if ($this.find('.swiper-slide').length <= 3) {
            $this.closest('.cb-membership-cards__carousel-block').addClass("disabled");
          }
        },
        slideChange: function() {
            var currentIndex = membershipCards.realIndex+1;
            $this.find('.liveregion').html('Item '+currentIndex+' of '+$this.find(".swiper-slide:not(.swiper-slide-duplicate)").length);
        },
      },
    });
    membershipCards.init();
  });

  // Pricing Chart (Type One)
  $(".cb-pricing-chart.cb-pricing-chart--type-one .cb-pricing-chart__items-block .swiper-container").each(function (index, element) {
    var $this = $(this);
    $this.addClass("pricing-chart-type-one-" + index);
    $this.parent().find('.swiper-button-next').addClass("swiper-button-next-pricing-chart-type-one-" + index);
    $this.parent().find('.swiper-button-prev').addClass("swiper-button-prev-pricing-chart-type-one-" + index);
    var pricingChart = new Swiper(".pricing-chart-type-one-" + index, {
      init: false,
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 2,
      speed: 750,
      mousewheel: {
        sensitivity: 1,
        forceToAxis: true,
        invert: true
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      observer: true,
      on: {
        init: function () {  
          var viewport = $(window);
          if (viewport.width() >= 768) {
            if ($this.find('.swiper-slide').length <= 3) {
              $this.closest('.cb-pricing-chart__items-block').addClass("disabled");
            }
          } else {
            $this.closest('.cb-pricing-chart__items-block').removeClass("disabled"); 
          }
        },
        resize: function () {  
          var viewport = $(window);
          if (viewport.width() >= 768) {
            if ($this.find('.swiper-slide').length <= 3) {
              $this.closest('.cb-pricing-chart__items-block').addClass("disabled");
            }
          } else {
            $this.closest('.cb-pricing-chart__items-block').removeClass("disabled"); 
          }
        },
        slideChange: function() {
            var currentIndex = pricingChart.realIndex+1;
            $this.find('.liveregion').html('Item '+currentIndex+' of '+$this.find(".swiper-slide:not(.swiper-slide-duplicate)").length);
        },
        reachEnd: function() {
          pricingChart.updateSize();
          pricingChart.updateSlides();
        },
      },
    });
    pricingChart.init();
  });


  // Card Carousel (Type One)
  $(".cb-card-carousel.cb-card-carousel--type-one .cb-card-carousel__items-block .swiper-container").each(function (index, element) {
    var $this = $(this);
    $this.addClass("card-carousel-type-one-" + index);
    $this.parent().find('.swiper-button-next').addClass("swiper-button-next-card-carousel-type-one-" + index);
    $this.parent().find('.swiper-button-prev').addClass("swiper-button-prev-card-carousel-type-one-" + index);
    var cardCarousel = new Swiper(".card-carousel-type-one-" + index, {
      init: false,
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 8,
      speed: 750,
      mousewheel: {
        sensitivity: 1,
        forceToAxis: true,
        invert: true
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      navigation: {
        nextEl: '.swiper-button-next.swiper-button-next-card-carousel-type-one-' + index,
        prevEl: '.swiper-button-prev.swiper-button-prev-card-carousel-type-one-' + index
      },
      on: {
        init: function () {
          if ($this.find('.swiper-slide').length <= 3) {
            // $this.closest('.cb-card-carousel__items-block').addClass("disabled");
          }
        },
        slideChange: function() {
            var currentIndex = cardCarousel.realIndex+1;
            $this.find('.liveregion').html('Item '+currentIndex+' of '+$this.find(".swiper-slide:not(.swiper-slide-duplicate)").length);
        },
      },
    });
    cardCarousel.init();
  });


  // Card Carousel (Type One)
  $(".cb-image-carousel.cb-image-carousel--type-one .cb-image-carousel__items-block .swiper-container").each(function (index, element) {
    var $this = $(this);
    $this.addClass("image-carousel-type-one-" + index);
    $this.parent().find('.swiper-button-next').addClass("swiper-button-next-image-carousel-type-one-" + index);
    $this.parent().find('.swiper-button-prev').addClass("swiper-button-prev-image-carousel-type-one-" + index);
    var imageCarousel = new Swiper(".image-carousel-type-one-" + index, {
      init: false,
      slidesPerView: 'auto',
      spaceBetween: 8,
      mousewheel: {
        sensitivity: 1,
        forceToAxis: true,
        invert: true
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      navigation: {
        nextEl: '.swiper-button-next.swiper-button-next-image-carousel-type-one-' + index,
        prevEl: '.swiper-button-prev.swiper-button-prev-image-carousel-type-one-' + index
      },
      observer: true,
      on: {
        reachEnd: function() {
          imageCarousel.updateSize();
          imageCarousel.updateSlides();
        },
        slideChange: function() {
            var currentIndex = imageCarousel.realIndex+1;
            $this.find('.liveregion').html('Item '+currentIndex+' of '+$this.find(".swiper-slide:not(.swiper-slide-duplicate)").length);
        },
      },
    });
    imageCarousel.init();
  });


  // Card Carousel (Type One)
  $(".cb-columns-image-text.cb-columns-image-text--type-one .cb-columns-image-text__items-block .swiper-container.items--3").each(function (index, element) {
    var $this = $(this);
    $this.addClass("columns-image-text-type-one-" + index);
    $this.parent().find('.swiper-button-next').addClass("swiper-button-next-columns-image-text-type-one-" + index);
    $this.parent().find('.swiper-button-prev').addClass("swiper-button-prev-columns-image-text-type-one-" + index);
    var cardCarousel = new Swiper(".columns-image-text-type-one-" + index, {
      init: false,
      loop: false,
      slidesPerView: 2,
      spaceBetween: 0,
      speed: 750,
      mousewheel: {
        sensitivity: 1,
        forceToAxis: true,
        invert: true
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      navigation: {
        nextEl: '.swiper-button-next.swiper-button-next-columns-image-text-type-one-' + index,
        prevEl: '.swiper-button-prev.swiper-button-prev-columns-image-text-type-one-' + index
      },
      on: {
        init: function () {
        },
        slideChange: function() {
            var currentIndex = cardCarousel.realIndex+1;
            $this.find('.liveregion').html('Item '+currentIndex+' of '+$this.find(".swiper-slide:not(.swiper-slide-duplicate)").length);
        },
      },
    });
    cardCarousel.init();
  });

}
